// extracted by mini-css-extract-plugin
export default {"container":"container__EpigenomesActivityContainer__ilCLl","loaderContainer":"loaderContainer__EpigenomesActivityContainer__ilCLl"};